import React from "react";

import { cx } from "../../utils/functions";

interface CardProps {
  children?: React.JSX.Element | React.JSX.Element[];
  className?: string;
  variant?: "primary" | "darkerPrimary" | "secondary" | "green" | "red" | "panel" | "subtle" | "silver";
}

const variants = {
  darkerPrimary: {
    background: "bg-[#fcf4d6]",
    stroke: "border-[#eaddc9]",
  },
  primary: {
    background: "bg-[#fefcf3]",
    stroke: "border-[#eaddc9]",
  },
  secondary: {
    background: "bg-[#fff]",
    stroke: "border-[#eaddc9]",
  },
  panel: {
    background: "bg-amber-50",
    stroke: "border-[#eaddc9]",
    radius: "rounded-xl",
  },
  subtle: {
    background: "bg-white/85",
    stroke: "border-[#eaddc9]",
    radius: "rounded-xl",
  },
  green: {
    background: "bg-green-50",
    stroke: "border-green-200",
  },
  red: {
    background: "bg-red-50",
    stroke: "border-red-200",
  },
  silver: {
    // card-silver (App.css) sets the light-silver background + silver-accent
    // border via the --l0-silver* tokens.
    background: "card-silver",
    stroke: "",
  }
};

export const Card = ({ children, className, variant }: CardProps) => {
  return (
    <div
      className={cx(
        "card shadow-sm",
        "border-2 border-solid",
        !variant && "bg-base-100",
        variant === "primary" &&
        `${variants.primary.background} ${variants.primary.stroke}`,
        variant === "secondary" &&
        `${variants.secondary.background} ${variants.secondary.stroke}`,
        variant === "darkerPrimary" &&
        `${variants.darkerPrimary.background} ${variants.darkerPrimary.stroke}`,
        variant === "panel" &&
        `${variants.panel.background} ${variants.panel.stroke} ${variants.panel.radius}`,
        variant === "subtle" &&
        `${variants.subtle.background} ${variants.subtle.stroke} ${variants.subtle.radius}`,
        variant === "green" &&
        `${variants.green.background} ${variants.green.stroke}`,
        variant === "red" &&
        `${variants.red.background} ${variants.red.stroke}`,
        variant === "silver" &&
        `${variants.silver.background} ${variants.silver.stroke}`,
        className,
      )}
    >
      {children}
    </div>
  );
};
